module.exports = __webpack_public_path__ + "static/media/logoTape.27f27ce6.png";